import { useState, useEffect } from "react";
import Page from "../components/Page";
import ImageStack from "../components/ImageStack";
import { Link } from "react-router-dom";
import artData from "../content/artData";

const Art = (props) => {
  const [innerContent, setInnerContent] = useState("");
  const [innerContentEN, setInnerContentEN] = useState("");

  useEffect(() => {
    fetch("./content/art-NL.html")
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        setInnerContent(html);
      });

    fetch("./content/art-EN.html")
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        setInnerContentEN(html);
      });
  });

  const content = (
    <div
      className="content"
      dangerouslySetInnerHTML={{ __html: innerContent ? innerContent : "" }}
    ></div>
  );

  const contentEN = (
    <div
      className="content"
      dangerouslySetInnerHTML={{ __html: innerContentEN ? innerContentEN : "" }}
    ></div>
  );

  const outsideContent = (
    <div className="blog-item__container-wrapper page__blog">
      {artData.map((post, index) => {
        return (
          <div className="blog-item__container" key={index}>
            <Link to={`/art/${index}`} state={post}>
              <span className="blog-item__image img-opacity">
                {/*<Link to={`/blog-post/${post.title}`} text={post.text}/>*/}
                <ImageStack image={post.introImage} />
              </span>

              <div className="blog-item__info">
                <div className="blog-item__title ff">
                  <span className="blog-item__title-link">{post.title}</span>
                </div>
                {/* <div className="blog-item__intro ff">
              <span className="blog-item__category ff">Art DS</span>
            </div> */}
                <span className="blog-item__link ff">{post.intro}</span>
              </div>
            </Link>
          </div>
        );
      })}
    </div>
  );

  document.title = "Art DS - De School Amsterdam";
  const headerTitle = "Art DS";
  const description = "Art Art Art Art Art Art Art Art Art Art Art Art ";

  return (
    <Page
      headerTitle={headerTitle}
      description={description}
      content={props.langNL ? content : contentEN}
      // image={image}
      langNL={props.langNL}
      outsideContent={outsideContent}
      changeLang={props.changeLang}
    />
  );
};

export default Art;
